import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {DialogConfirmProps} from "./DialogConfirm.props";
import './DialogConfirm.css';

const BootstrapDialog = styled(Dialog)(() => ({
  '& .MuiDialogActions-root': {
    padding: '18px 24px',
  },
  '& .MuiDialogTitle-root': {
    padding: '24px 24px 10px 24px',
  },
  '& .MuiIconButton-root': {
    marginTop: '17px'
  },
  '& .MuiDialogContent-root': {
    padding: '10px 24px',
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: 14
  },
  '& .MuiButton-root': {
    padding: '8px 16px',
    fontFamily: 'Montserrat',
    height: 40,
    fontWeight: 600,
    fontSize: 14
  },
}));

export const DialogConfirm: React.FC<DialogConfirmProps> = (props) => {

  return (
    <React.Fragment>
      <BootstrapDialog
        data-testid= 'dialog-confirm'
        onClose={props.handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          <p className={'dialog-confirm-title'}>{props.title}</p>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={props.handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers >
          {props.content}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={props.handleClose} data-testid= 'dialog-confirm-cancel'>Cancel</Button>
          <Button variant="contained" onClick={props.handleSave} data-testid= 'dialog-confirm-ok'>Review</Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}